// extracted by mini-css-extract-plugin
module.exports = {"container":"SectionCharge_container__2xtPF","left":"SectionCharge_left__2Bwt2","right":"SectionCharge_right__pagt0"};